export default "__VITE_ASSET__I$TShXSi__"